const EDIT_APP_ACCESS_RULE_DRAFT_PREFIX = 'admin:appAccessRuleDraft:edit:'
export const NEW_APP_ACCESS_RULE_DRAFT_KEY = 'admin:appAccessRuleDraft:new'

const DEFAULT_FORM = {
    title: '',
    content: '',
    actionType: 'NOTICE',
    priority: 0,
    isActive: true,
}

const getSessionStorage = () => {
    if (typeof window === 'undefined') {
        return null
    }

    return window.sessionStorage
}

const normalizeTextValue = (value) => {
    if (value === undefined || value === null) {
        return ''
    }

    return String(value)
}

const normalizeNumberValue = (value, fallbackValue = 0) => {
    if (value === undefined || value === null || value === '') {
        return fallbackValue
    }

    const parsedValue = Number(value)

    return Number.isNaN(parsedValue) ? fallbackValue : parsedValue
}

const normalizeBooleanValue = (value, fallbackValue = true) => {
    if (value === undefined || value === null) {
        return fallbackValue
    }

    return Boolean(value)
}

const normalizeConditionRows = (conditionRows = []) => {
    return conditionRows.map((condition) => ({
        conditionType: normalizeTextValue(condition?.conditionType),
        operator: normalizeTextValue(condition?.operator),
        value: normalizeTextValue(condition?.value),
    }))
}

const normalizeTargetRows = (targetRows = []) => {
    return targetRows.map((target) => ({
        targetType: normalizeTextValue(target?.targetType || 'ALL'),
        value: normalizeTextValue(target?.value),
    }))
}

// 앱 접근 정책 폼은 운영자가 다시 입력 비용이 큰 기본 정보와 조건/타겟 배열만 sessionStorage에 남긴다.
export const createAppAccessRuleDraftPayload = ({ form = {}, conditions = [], targets = [] } = {}) => {
    return {
        form: {
            title: normalizeTextValue(form.title),
            content: normalizeTextValue(form.content),
            actionType: normalizeTextValue(form.actionType || DEFAULT_FORM.actionType),
            priority: normalizeNumberValue(form.priority, DEFAULT_FORM.priority),
            isActive: normalizeBooleanValue(form.isActive, DEFAULT_FORM.isActive),
        },
        conditions: normalizeConditionRows(conditions),
        targets: normalizeTargetRows(targets),
    }
}

// 서버 기본값 위에 draft만 덮어써서 새로고침 뒤에도 정책 작성 흐름을 이어간다.
export const applyAppAccessRuleDraft = ({ baseForm = {}, baseConditions = [], baseTargets = [], draft }) => {
    const normalizedBaseDraft = createAppAccessRuleDraftPayload({
        form: baseForm,
        conditions: baseConditions,
        targets: baseTargets,
    })

    if (!draft) {
        return {
            form: {
                ...baseForm,
                ...normalizedBaseDraft.form,
            },
            conditions: normalizedBaseDraft.conditions,
            targets: normalizedBaseDraft.targets,
        }
    }

    const draftForm = draft.form || {}

    return {
        form: {
            ...baseForm,
            title: draftForm.title === undefined ? normalizedBaseDraft.form.title : normalizeTextValue(draftForm.title),
            content: draftForm.content === undefined ? normalizedBaseDraft.form.content : normalizeTextValue(draftForm.content),
            actionType: draftForm.actionType === undefined ? normalizedBaseDraft.form.actionType : normalizeTextValue(draftForm.actionType),
            priority: draftForm.priority === undefined
                ? normalizedBaseDraft.form.priority
                : normalizeNumberValue(draftForm.priority, normalizedBaseDraft.form.priority),
            isActive: draftForm.isActive === undefined
                ? normalizedBaseDraft.form.isActive
                : normalizeBooleanValue(draftForm.isActive, normalizedBaseDraft.form.isActive),
        },
        conditions: draft.conditions === undefined ? normalizedBaseDraft.conditions : normalizeConditionRows(draft.conditions),
        targets: draft.targets === undefined ? normalizedBaseDraft.targets : normalizeTargetRows(draft.targets),
    }
}

export const createEditAppAccessRuleDraftKey = (appAccessRuleId) => `${EDIT_APP_ACCESS_RULE_DRAFT_PREFIX}${appAccessRuleId}`

export const readAppAccessRuleDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return null
    }

    try {
        const storedValue = storage.getItem(draftKey)
        return storedValue ? JSON.parse(storedValue) : null
    } catch (_error) {
        return null
    }
}

export const saveAppAccessRuleDraft = (draftKey, draftValue) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.setItem(draftKey, JSON.stringify(draftValue))
    } catch (_error) {
        // sessionStorage가 막혀 있어도 작성 흐름은 그대로 유지한다.
    }
}

export const clearAppAccessRuleDraft = (draftKey) => {
    const storage = getSessionStorage()

    if (!storage || !draftKey) {
        return
    }

    try {
        storage.removeItem(draftKey)
    } catch (_error) {
        // storage 정리에 실패해도 화면 동작은 계속 진행한다.
    }
}
